export default {
	data() {
		return {
			maxDevicePerPage: 100
		};
	},
	computed: {
		isBackendSearchUsed() {
			return this.$store.state.devices.total > this.maxDevicePerPage;
		}
	}
};



// WEBPACK FOOTER //
// ./app/mixins/search.js